import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  Input,
  Modal,
  Radio,
  Select,
  Typography,
} from "antd";
import { useState, useEffect } from "react";
import {
  DealerPunchOrderRequest,
  DeleteDealerCart,
} from "../../../redux/actions/userActions/ordersActions";
import Alertify from "../../../services/alertify";
const { Title } = Typography;
const OrderDetailsModal = (props) => {
  const {
    dispatch,
    email,
    today,
    authData,
    dealer_code,
    orderDetailsModal,
    setOrderDetailsModal,
    orderDetails,
    setOrderDetails,
    shippingDetails,
    balanceCredit,
    subTotal,
    totalGST,
    grandTotal,
    cartItems,
    setCartItems,
    shipmentType,
    setLocation,
  } = props;
  const [currentDealer, setCurrentDealer] = useState();

  useEffect(() => {
    if (authData?.dealer_codes) {
      if (
        Array.isArray(authData.dealer_codes) &&
        authData.dealer_codes.length > 1
      ) {
        const foundDealer = authData.dealer_codes.find(
          (dealer) => dealer?.dealer_id === dealer_code,
        );
        setCurrentDealer(foundDealer);
      } else {
        setCurrentDealer(authData?.dealer_codes?.dealer_id);
      }
    }
  }, [authData?.dealer_codes, dealer_code]);
  const PunchOrderRequest = () => {
    const payload = {
      dealer_code: dealer_code,
      dealerName: authData?.name,
      email: email,
      mblNumber: authData?.mobile ?? null,
      gst: currentDealer?.gst,
      balance_credit: balanceCredit,
      shipAddresses:
        shippingDetails?.street +
        ", " +
        shippingDetails?.city +
        ", " +
        shippingDetails?.state +
        ", " +
        shippingDetails?.pincode,
      shipAddressLine1: shippingDetails?.street,
      shipAddressLine2: shippingDetails?.address_2,
      shipCity: shippingDetails?.city,
      shipPin: shippingDetails?.pincode,
      shipState: shippingDetails?.state,
      shipName: shippingDetails?.name,
      shipName2: shippingDetails?.name_2,
      ship_code: shippingDetails?.code,
      dealerShipping: shippingDetails?.dealer_code,
      billAddressLine1: currentDealer?.address,
      billAddressLine2: currentDealer?.address2,
      billState: currentDealer?.state,
      billCity: currentDealer?.city,
      billPin: currentDealer?.pincode,
      orderType: orderDetails?.orderType ?? "Normal Order",
      requestedDate: orderDetails?.requestedDate,
      project_type: orderDetails?.project_type,
      project_segment: orderDetails?.project_segment,
      doc_number: orderDetails?.doc_number,
      note: orderDetails?.note,
      transaction_type: "cod",
      transaction_type_title: "Pay Later",
      freight_type: shipmentType,
      subTotal: subTotal,
      totalGST: totalGST,
      grandTotal: grandTotal,
      payment_method: "cod",
      products: cartItems.map((items) => {
        return {
          pad: items?.pad,
          alp_code: items?.sku,
          title: items?.name,
          packaging_quantity_wholesaler_box: items?.packQty,
          unit_price: items?.unitPrice,
          boxPrice: items?.boxPrice,
          quantity: items?.qty,
          discount: items?.discount ?? 0,
          total_price: items?.total_price,
          gst: items?.gst,
          gstNumber: items?.gstAmount,
          final_price: items?.finalPrice,
          msp: items?.msp_price,
        };
      }),
    };
    dispatch(DealerPunchOrderRequest(payload))
      .then((response) => {
        console.log("Order Request Response:", response);
        Alertify.success("Order request placed successfully!");
        dispatch(DeleteDealerCart({ dealerCode: dealer_code })).then(() => {
          setCartItems([]);
          setLocation("/orders");
        });
        setOrderDetailsModal(false);
      })
      .catch((error) => {
        console.error("Error Punch Order Request:", error);
      });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: { titleMarginTop: 0, titleMarginBottom: 0 },
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <Modal
        open={orderDetailsModal}
        onCancel={() => setOrderDetailsModal(false)}
        footer={false}
        width={800}
        centered
      >
        <div className="text-center">
          <InfoCircleOutlined className="text-gray-500 text-3xl mb-2" />
          <Title level={3}>You are placing an order request</Title>
          <p className="text-lg sm:text-lg">
            Soon after placing this request, you will receive an order
            confirmation link on <strong>{email}</strong> with the shipping cost
            from ALP.
          </p>
        </div>

        <Title level={4} className="mt-4">
          Choose Order Type:
        </Title>
        <Radio.Group
          value={orderDetails.orderType}
          onChange={(e) =>
            setOrderDetails({
              ...orderDetails,
              orderType: e.target.value,
            })
          }
          options={[
            { label: "Normal Order", value: "Normal Order" },
            { label: "Blanket Order", value: "Blanket Order" },
          ]}
        />
        <div className="flex items-center justify-between mt-4">
          <strong>Requested Date:</strong>
          <Input
            type="date"
            id="date"
            min={today}
            value={orderDetails.requestedDate}
            onChange={(e) =>
              setOrderDetails({
                ...orderDetails,
                requestedDate: e.target.value,
              })
            }
            className="w-1/2"
          />
        </div>
        <div className="flex items-center justify-between mt-4">
          <strong>Project Type:</strong>
          <Select
            className="w-1/2"
            value={orderDetails.project_type}
            onChange={(value) =>
              setOrderDetails({
                ...orderDetails,
                project_type: value,
              })
            }
            options={[
              { label: "Private", value: "Private" },
              { label: "Government", value: "Government" },
            ]}
          />
        </div>
        <div className="flex items-center justify-between mt-4">
          <strong>Project Segment:</strong>
          <Select
            className="w-1/2"
            placeholder="Select Segment"
            value={orderDetails.project_segment}
            onChange={(value) =>
              setOrderDetails({
                ...orderDetails,
                project_segment: value,
              })
            }
            options={[
              {
                label: "Power Plant",
                value: "Power Plant",
              },
              {
                label: "Hospital",
                value: "Hospital",
              },
              {
                label: "Mall/Multiplex",
                value: "Mall/ Mutiplex",
              },
              {
                label: "IT/ITES",
                value: "IT/ITES",
              },
              {
                label: "Office Building",
                value: "Office Building",
              },
              {
                label: "OEM",
                value: "OEM",
              },
              {
                label: "Institution",
                value: "Institution",
              },
              {
                label: "Defence",
                value: "Defence",
              },
              {
                label: "Hotel",
                value: "Hotel",
              },
              {
                label: "Refinery",
                value: "Refinery",
              },
              {
                label: "Dairy",
                value: "Dairy",
              },
              {
                label: "Metro",
                value: "Metro",
              },
              {
                label: "Airport",
                value: "Airport",
              },
              {
                label: "Railways",
                value: "Railways",
              },
              {
                label: "Pharma",
                value: "Pharma",
              },
              {
                label: "Process",
                value: "Process",
              },
              {
                label: "Factory",
                value: "Factory",
              },
              {
                label: "Cold Storage",
                value: "Cold Storage",
              },
              {
                label: "Warehouse",
                value: "Warehouse",
              },
              {
                label: "Eco sheet - Non Specified Projects",
                value: "Eco sheet - Non Specified Projects",
              },
              {
                label: "Eco Tube/tapes - Retail Market",
                value: "Eco Tube/tapes - Retail Market",
              },
            ]}
          />
        </div>
        <div className="flex items-center justify-between mt-4">
          <strong>External Document Number:</strong>
          <Input
            type="text"
            value={orderDetails.doc_number}
            onChange={(e) =>
              setOrderDetails({
                ...orderDetails,
                doc_number: e.target.value,
              })
            }
            placeholder="External Document Number"
            className="w-1/2"
          />
        </div>
        <p className="mt-4">
          <strong>Note for relationship manager:</strong>
        </p>
        <Input.TextArea
          placeholder="Please enter your note here..."
          onChange={(e) =>
            setOrderDetails({ ...orderDetails, note: e.target.value })
          }
          value={orderDetails.note}
        />
        <div className="flex gap-5 justify-center">
          <Button
            type="primary"
            className="bg-[#B91C1C] rounded-lg sm:w-fit w-1/2 mt-4"
            onClick={() => PunchOrderRequest()}
          >
            PLACE ORDER REQUEST
          </Button>
          <Button
            className="rounded-lg sm:w-fit w-1/2 mt-4"
            onClick={() => setOrderDetailsModal(false)}
          >
            CANCEL
          </Button>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default OrderDetailsModal;
